import { FormsModule } from '@angular/forms';
import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { BannerListComponent } from './banner-list.component';
import { PaginationModule } from 'ngx-bootstrap';
import { ModalsModule } from './Modals/Modals.module';
import { NgSelectModule } from '@ng-select/ng-select';
import { ModalsComponent } from './Modals/Modals.component';
import { HttpClientModule } from '@angular/common/http';

@NgModule({
  imports: [
    CommonModule,
    PaginationModule,
    FormsModule,
    ModalsModule,
    NgSelectModule,
    HttpClientModule
  ],
  declarations: [
    BannerListComponent
  ]
})
export class BannerListModule { }
